// src/pages/Terms.js
import React from 'react';
import './Terms.css'; // Optional: add styling if needed

function Terms() {
  return (
    <div className="terms-container" style={{ padding: '2rem', maxWidth: '900px', margin: '0 auto' }}>
      <h1>Terms and Conditions for SnapConX</h1>
      <p><strong>Effective Date:</strong> 4 July 2025 · <strong>Last updated:</strong> 14 October 2026</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using the SnapConX mobile app, website or dashboard (together, "SnapConX"), you agree to be bound by these Terms and Conditions
        (the "Agreement"). If you do not agree with these terms, do not use SnapConX.
      </p>

      <h2>2. Changes to Terms</h2>
      <p>
        Dot and Dash Trading CC reserves the right to modify these Terms and Conditions at any time. Changes will
        be posted on this page and are effective immediately upon posting. You are encouraged to review these
        terms regularly.
      </p>

      <h2>3. Use of SnapConX</h2>
      <p>You agree to use SnapConX in compliance with all applicable laws and regulations and for lawful purposes only. You may not use SnapConX to:</p>
      <ul>
        <li>Violate any laws, infringe upon intellectual property rights, or harm others</li>
        <li>Engage in fraudulent or illegal activities</li>
        <li>Interfere with SnapConX’s functionality or security</li>
      </ul>

      <h2>4. User Accounts</h2>
      <p>
        Some features of SnapConX will require you to create an account. You agree to provide accurate,
        current, and complete information during registration. You are responsible for maintaining the
        confidentiality of your account credentials and are liable for any activity under your account.
      </p>

      <h2>5. Age Requirements and Digital Consent</h2>
      <p>
        You must be at least 18 years old to use this application. If you are under the age of 18 but at least 16,
        you may only use this application with the consent and supervision of a parent or legal guardian who agrees
        to be bound by these Terms.
      </p>

      <h2>6. Privacy and Data Collection</h2>
      <p>
        Your use of SnapConX is subject to our Privacy Policy, which outlines how we collect, use, and protect
        your personal data.
      </p>

      <h2>7. Intellectual Property</h2>
      <p>
        SnapConX, including all its content (text, graphics, logos, icons, and software), is the property of
        Dot and Dash Trading CC or its licensors and is protected by copyright and intellectual property laws.
      </p>

      <h2>8. License to Use SnapConX</h2>
      <p>
        Dot and Dash Trading CC grants you a limited, non-transferable, non-exclusive license to use SnapConX
        for commercial purposes.
      </p>

      <h2>9. Monetary Policy and Administrative Charges</h2>
      <p>
        An administrative fee will be applied to all bookings made through SnapConX. These charges will be
        shown clearly before confirming any booking.
      </p>

      <h2>10. Third-Party Links and Services</h2>
      <p>
        SnapConX may contain links to third-party websites. Use them at your own risk—we are not responsible
        for their accuracy or reliability.
      </p>

      <h2>11. Disclaimer of Warranties</h2>
      <p>
        SnapConX is provided “as is,” without any warranty, including but not limited to warranties of
        merchantability or fitness for a particular purpose.
      </p>

      <h2>12. Limitation of Liability</h2>
      <p>
        Dot and Dash Trading CC will not be liable for any indirect or consequential damages resulting from your
        use of SnapConX.
      </p>

      <h2>13. Termination</h2>
      <p>
        We may suspend or terminate your access at any time without notice if you violate any of these Terms.
      </p>

      <h2>14. Governing Law</h2>
      <p>
        These terms are governed by the laws of the country in which SnapConX is used.
      </p>

      <h2>15. Contact Information</h2>
      <p>Email: <a href="mailto:info@dotanddash.co.za">info@dotanddash.co.za</a></p>

      <h2>16. Optional Calendar Synchronization</h2>
      <p>
        You may connect Google Calendar, Microsoft Outlook, or both and choose a calendar for eligible
        SnapConX appointment copies. By enabling synchronization, you authorize SnapConX to create,
        update and remove its managed appointment events in the selected calendar. Only connect accounts
        you are entitled to use. Business calendar connections must be authorized by the business owner.
      </p>
      <p>
        Manage bookings, rescheduling and cancellations in SnapConX. Changing or deleting an event directly
        in Google or Outlook does not change the original SnapConX booking. Calendar synchronization does
        not establish payment confirmation, cancel a booking, or issue a refund.
      </p>
      <p>
        Synchronization depends on provider availability, valid authorization and network access. Events
        may be delayed or fail to synchronize. Check the appointment details and synchronization status in
        SnapConX rather than relying solely on an external calendar. A provider or workplace administrator
        may restrict access or require you to reconnect.
      </p>
      <p>
        You can disable synchronization or disconnect in Calendar connections. Existing managed event
        copies may be removed during cleanup; unrelated calendar events and the original SnapConX bookings
        are not cancelled by disconnecting. Cleanup may be delayed or require support if provider access
        is unavailable. You can also revoke authorization in your provider account settings.
      </p>
      <p>
        See our <a href="/privacy">Privacy Policy</a> for calendar permissions, data use, storage,
        protection and deletion. Google and Microsoft services are also subject to their own applicable
        terms and privacy policies.
      </p>
    </div>
  );
}

export default Terms;
